import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      confirmDisabled: true
    };
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    withoutFooter: {
      type: Boolean,
      default: false
    },
    withoutHeader: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    html: {
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    cancelButtonText: {
      default: 'Cancel'
    },
    cancelButtonColor: {
      default: 'white'
    },
    confirmButtonText: {
      default: 'Confirm'
    },
    confirmButtonColor: {
      default: 'positive'
    },
    onConfirm: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    onCancel: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    confirmTimeout: {
      default: 2000
    }
  },
  computed: {
    titleColorClass: function titleColorClass() {
      switch (this.type) {
        case 'warning':
        case 'danger':
          return 'text-white';

        default:
          return '';
      }
    }
  },
  methods: {
    cancel: function cancel() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.showLoading();

                _context.next = 3;
                return _this.onCancel();

              case 3:
                _this.hideLoading();

                _this.hide();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    confirm: function confirm() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.showLoading();

                _context2.next = 3;
                return _this2.onConfirm();

              case 3:
                _this2.hideLoading();

                _this2.hide();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    setTimeout(function () {
      _this3.confirmDisabled = false;
    }, this.confirmTimeout);
  }
};